const cusDashedLine = function (ctx, x, y, x2, y2, dashArray, c) {
  ctx.strokeStyle = c
  ctx.beginPath()

  if (!dashArray) dashArray = [10, 5]
  // Hack for Safari
  // if (dashLength === 0) {
  //   dashLength = 0.001
  // }
  const dashCount = dashArray.length
  ctx.moveTo(x, y)
  // eslint-disable-next-line one-var
  let dx = (x2 - x), dy = (y2 - y)
  let slope = dy / dx
  if (dx === 0) {
    slope = dx / dy
  }
  let distRemaining = Math.sqrt(dx * dx + dy * dy)
  // eslint-disable-next-line one-var
  let dashIndex = 0, draw = true
  while (distRemaining >= 0.1) {
    let dashLength = dashArray[dashIndex++ % dashCount]
    if (dashLength > distRemaining) {
      dashLength = distRemaining
    }
    let xStep = Math.sqrt(dashLength * dashLength / (1 + slope * slope))

    if (dx === 0) {
      if (dy < 0) {
        xStep = -xStep
      }
      x += slope * xStep
      y += xStep
    } else {
      if (dx < 0) {
        xStep = -xStep
      }
      x += xStep
      y += slope * xStep
    }
    ctx[draw ? 'lineTo' : 'moveTo'](x, y)
    distRemaining -= dashLength
    draw = !draw
  }

  ctx.lineCap = 'round'
  ctx.stroke()
}

const cusSolidLine = function (ctx, x, y, x2, y2, w, c) {
  ctx.lineWidth = w
  ctx.strokeStyle = c
  ctx.lineCap = 'round'
  ctx.beginPath()
  ctx.moveTo(x, y)
  ctx.lineTo(x2, y2)
  ctx.stroke()
}

// const cusSolidLines = function (ctx, points, w, c, t) {
//   let i = 2
//   const length = points.length
//   if (length % 2 !== 0) return
//
//   ctx.lineWidth = w
//   ctx.lineJoin = t
//   ctx.strokeStyle = c
//   ctx.beginPath()
//   ctx.moveTo(points[0], points[1])
//
//   for (; i < length; i += 2) {
//     ctx.lineTo(points[i], points[i + 1])
//   }
//
//   ctx.stroke()
// }

/**
 * 创建高分辨率画布
 * @param w     画布宽
 * @param h     画布高
 * @param ratio 屏幕分辨率
 */
function createCanvas (w, h, ratio) {
  const PIXEL_RATIO = (function () {
    // eslint-disable-next-line one-var
    const c = document.createElement('canvas'),
      ctx = c.getContext('2d'),
      dpr = ratio || 1,
      bsr = ctx['webkitBackingStorePixelRatio'] ||
        ctx['mozBackingStorePixelRatio'] ||
        ctx['msBackingStorePixelRatio'] ||
        ctx['oBackingStorePixelRatio'] ||
        ctx['backingStorePixelRatio'] || 1

    return dpr / bsr
  })()

  if (!ratio) {
    ratio = PIXEL_RATIO
  }
  const canvas = document.createElement('canvas')
  canvas.width = w * ratio
  canvas.height = h * ratio
  canvas.style.width = w + 'px'
  canvas.style.height = h + 'px'
  canvas.getContext('2d').setTransform(ratio, 0, 0, ratio, 0, 0)
  return canvas
}

function drawDashedLine (ctx, x1, y1, x2, y2, color, lineWidth, opacity) {
  color = rgb(color, opacity)
  ctx.lineWidth = lineWidth
  cusDashedLine(ctx, parseInt(x1) + 0.5, parseInt(y1) + 0.5, parseInt(x2) + 0.5, parseInt(y2) + 0.5, [2, 2], color)
}

function drawLine (ctx, x1, y1, x2, y2, color, lineWidth, opacity) {
  color = rgb(color, opacity)
  cusSolidLine(ctx, parseInt(x1) + 0.5, parseInt(y1) + 0.5, parseInt(x2) + 0.5, parseInt(y2) + 0.5, lineWidth, color)
}

function drawGrid (ctx, width, height, x, y, cellWidth, cellHeight, spaceNumHori, spaceNumVert, offset, lineWidth, lineColor, opacity) {
  // 绘制横线
  // eslint-disable-next-line one-var
  let _y = 0, count = 0
  for (; _y < parseInt(height); _y += cellHeight) {
    let tmpY = _y + y
    if ((count + 1) % spaceNumHori === 1) {
      drawLine(ctx, x, tmpY, width + x, tmpY, lineColor, lineWidth, opacity)
    } else {
      drawDashedLine(ctx, x, tmpY, width + x, tmpY, lineColor, lineWidth, opacity)
    }
    count++
  }

  let _x = 0
  count = 0
  // 绘制竖线
  // ------------------------------- start --
  // 1cm时每隔30s绘制1条虚线；2cm时每隔15s绘制1条虚线；3cm时每隔10s绘制一条虚线；
  cellWidth = cellWidth / 2
  spaceNumVert = spaceNumVert * 2
  // ------------------------------- end --
  for (; _x < parseInt(width); _x += cellWidth) {
    let tmpX = _x + x
    if (spaceNumVert === 1) {
      drawLine(ctx, tmpX, y, tmpX, height + y, lineColor, lineWidth, opacity)
    } else {
      if (count === 0 || count === offset || ((count + 1 - offset) % (spaceNumVert) === 1)) {
        drawLine(ctx, tmpX, y, tmpX, height + y, lineColor, lineWidth, opacity)
      } else {
        drawDashedLine(ctx, tmpX, y, tmpX, height + y, lineColor, lineWidth, opacity)
      }
    }
    count++
  }

  drawLine(ctx, width + x, y, width + x, height + y, lineColor, lineWidth, opacity)
  drawLine(ctx, x, height + y, width + x, height + y, lineColor, lineWidth, opacity)
}

function drawRect (ctx, x, y, width, height, color, opacity) {
  color = rgb(color, opacity)
  ctx.fillStyle = color
  ctx.fillRect(x, y, width, height)
}

function drawSvg (ctx, path, x, y, width, height, color, opacity) {
  ctx.save()
  color = rgb(color, opacity || 1)
  ctx.fillStyle = color
  ctx.beginPath()
  ctx.translate(x, y)
  ctx.fill(new Path2D(path))
  ctx.restore()
}

function rgb (color, opacity) {
  let sColor = color
  const reg = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      // eslint-disable-next-line no-const-assign
      sColor = sColorNew
    }
    let sColorChange = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
    }
    sColorChange.push(opacity)
    return 'rgb(' + sColorChange.join(',') + ')'
  }
  return sColor
}

function measureFontHeight (canvas, ctx, fontStyle) {
  const sourceWidth = canvas.width
  const sourceHeight = canvas.height

  ctx.font = fontStyle

  // place the text somewhere
  ctx.textAlign = 'left'
  ctx.textBaseline = 'top'
  ctx.fillText('fißgPauljMPÜÖÄ', 25, 5)

  // returns an array containing the sum of all pixels in a canvas
  // * 4 (red, green, blue, alpha)
  // [pixel1Red, pixel1Green, pixel1Blue, pixel1Alpha, pixel2Red ...]
  const data = ctx.getImageData(0, 0, sourceWidth, sourceHeight).data

  let firstY = -1
  let lastY = -1

  // loop through each row
  for (let y = 0; y < sourceHeight; y++) {
    // loop through each column
    for (let x = 0; x < sourceWidth; x++) {
      // var red = data[((sourceWidth * y) + x) * 4];
      // var green = data[((sourceWidth * y) + x) * 4 + 1];
      // var blue = data[((sourceWidth * y) + x) * 4 + 2];
      const alpha = data[((sourceWidth * y) + x) * 4 + 3]

      if (alpha > 0) {
        firstY = y
        // exit the loop
        break
      }
    }
    if (firstY >= 0) {
      // exit the loop
      break
    }
  }

  // loop through each row, this time beginning from the last row
  for (let y = sourceHeight; y > 0; y--) {
    // loop through each column
    for (let x = 0; x < sourceWidth; x++) {
      const alpha = data[((sourceWidth * y) + x) * 4 + 3]
      if (alpha > 0) {
        lastY = y
        // exit the loop
        break
      }
    }
    if (lastY >= 0) {
      // exit the loop
      break
    }
  }

  return {
    // The actual height
    height: lastY - firstY,

    // The first pixel
    firstPixel: firstY,

    // The last pixel
    lastPixel: lastY
  }
}

function clear (canvas, ctx) {
  const box = canvas.getBoundingClientRect()
  ctx.clearRect(0, 0, box.width, box.height)
}

export default {
  createCanvas: createCanvas,
  drawGrid: drawGrid,
  drawLine: drawLine,
  drawRect: drawRect,
  drawSvg: drawSvg,
  measureFontHeight: measureFontHeight,
  clear: clear
}
